import { logError } from 'lib/observability';

/**
 * Decorator that wraps a method in try-catch, logs errors, and re-throws them
 */
export function LogError<T extends object, TArgs extends unknown[], TReturn>(
  target: T,
  propertyKey: string | symbol,
  descriptor: TypedPropertyDescriptor<(...args: TArgs) => Promise<TReturn>>
): void {
  const originalMethod = descriptor.value;

  descriptor.value = async function (...args: TArgs): Promise<TReturn> {
    const stacktrace = new Error().stack;
    const callTimestamp = new Date().toISOString();

    try {
      const result = await originalMethod!.apply(this, args);
      return result;
    } catch (error) {
      if (error instanceof Error) {
        error.stack += `\n\nCaused by:\n${stacktrace}`;
      }

      try {
        const className = (target.constructor as (() => unknown) & Record<string, unknown>).className;
        logError(error, `PlatformFacade: ${className}.${String(propertyKey)}`, { context: { callTimestamp } });
      } catch {
        logError(error, `PlatformFacade: ${target.constructor.name}.${String(propertyKey)}`, { context: { callTimestamp } });
      }
      throw error;
    }
  };
}
